module.exports = __webpack_public_path__ + "img/6a1cac990bf6d6aa090819ba5b6a8ad8.png";